import { PhoneNumberUtil, PhoneNumberFormat, PhoneNumberType } from 'google-libphonenumber';
import { Country } from 'country-state-city';
import { isListEmpty } from './object';

const phoneUtil = PhoneNumberUtil.getInstance();

export const formatPhone = (phoneNumber, region='US') => {
    if (phoneNumber === null || phoneNumber === '') return '';
    let countryIsoCode = (region?.toLowerCase() === "united states") ? 'US' : region; // old addresses have country set as 'united states'

    try {
        let number = phoneUtil.parse(phoneNumber, countryIsoCode);

        if (!number){
            countryIsoCode = getISOCode(region);
            number = phoneUtil.parse(phoneNumber,countryIsoCode);
        }
        //Return if the number isn't valid
        if (!phoneUtil.isValidNumber(number)) return phoneUtil.format(number, PhoneNumberFormat.INTERNATIONAL);

        let countryCode = number.values_[1];
        const formattedNumber = phoneUtil.format(number, PhoneNumberFormat.NATIONAL);
        return "+" + countryCode + " " + formattedNumber;
    } catch (e) {
        // the phone is not in a standard format, return the phone number as is
    }
    return phoneNumber;
};

export const getISOCode = (region) => {
    const country = Country.getAllCountries().find(country => country.name === region);
    return country?.isoCode
}

export const getPhoneMask = (region = 'US', includePhoneCode=true) => {
    let countryIsoCode = (region.toLowerCase() === "united states") ? 'US' : region; // old addresses have country set as 'united states'
    let sampleNumber = phoneUtil.getExampleNumberForType(countryIsoCode, PhoneNumberType.MOBILE);
    if(!sampleNumber){
        countryIsoCode = getISOCode(region) || 'us'
        sampleNumber = phoneUtil.getExampleNumberForType(countryIsoCode,PhoneNumberType.MOBILE)
    }
    let countryCode = sampleNumber?.values_[1];
    let formattedNumber = phoneUtil.format(phoneUtil.parse(sampleNumber?.values_[2].toString(), countryIsoCode), PhoneNumberFormat.NATIONAL)

    let mask = formattedNumber.replace(/\d/g, '0')
    let maskObj = mask.split(/([-() ])/).filter(Boolean).map( item => {
        if(item.includes('0')){
            return {
                length: item.length,
                placeholder: item,
                regexp: new RegExp("^[0-9]{1,"+item.length+"}$")
            }
        } else {
            return {
                fixed: item
            }
        }
    });

    return {
        placeholder: `${includePhoneCode ? `+${countryCode} ` : ""}${mask}`,
        formatted: [
            ...(includePhoneCode ? [
                {
                    fixed: "+" + countryCode,
                    placeholder: "+" + countryCode
                },
                {fixed: ' '},
            ] : []),
            ...maskObj,
            ...[
                {fixed: ' '},
                {fixed: 'ext.'},
                {fixed: ' '},
                {
                    regexp: /^[0-9]+$/,
                    placeholder: 'xxx',
                }
            ]
        ]
    };
};

export const isValidPhoneNumber = (phoneNumber) => {
    if (phoneNumber === null || phoneNumber === '') return false;
    try {
        const number = phoneUtil.parse(phoneNumber);
        return phoneUtil.isValidNumber(number);
    } catch (e) {
        // console.error(e);
        return false;
    }
}

export const isValidPhoneNumberForCountries = (phoneNumber, countries = []) => {
    if (phoneNumber === null || phoneNumber === '' || isListEmpty(countries)) return false;
    const cleanedPhoneNumber = phoneNumber.split(" ext. ")[0]; // ignore extension portion
    try {
        for (let i = 0; i < countries.length; i++) {
            if (isValidPhoneNumberForCountry(cleanedPhoneNumber, countries[i])) return true;
        }
        return false;
    } catch (e) {
        // console.error(e);
        return false;
    }
}

export const isValidPhoneNumberForCountry = (phoneNumber, country="US") => {
    if (phoneNumber === null || phoneNumber === '' || !country) return false;
    const cleanedPhoneNumber = phoneNumber.split(" ext. ")[0]; // ignore extension portion
    try {
        return phoneUtil.isValidNumberForRegion(phoneUtil.parse(cleanedPhoneNumber, country), country);
    } catch (e) {
        // console.error(e);
        return false;
    }
}

export const getCountriesByPhoneCode = (phoneCode) => {
    if (!phoneCode || !phoneCode.startsWith("+") || phoneCode.length < 2) return null;
    const code = phoneCode.split("+")[1];
    const allCountries = Country.getAllCountries();
    const countries = allCountries.filter(country => country.phonecode == code); // we need to return a list because some countries share the same code
    if(phoneCode == 1) countries.push(Country.getCountryByCode('PR')); // Add Puerto Rico if area code is +1. Google Phone Lib separates the two
    return countries;
}

export const getCountryByPhoneCode = (phoneCode) => {
    if (!phoneCode || !phoneCode.startsWith("+") || phoneCode.length < 2) return null;
    const code = phoneCode.split("+")[1];
    const allCountries = Country.getAllCountries();
    const ind = allCountries.findIndex(country => country.phonecode == code); // we need to return a list because some countries share the same code
    return ind >= 0 ? allCountries[ind] : null;
}